import axios from "axios";
var getApiDomain = function () {
    var env = process.env.CURRENT_ENV;
    if (["development"].includes(env))
        return "partner-apis-dev";
    if (env && ["staging", "local"].includes(env))
        return "hub-staging";
    return "hub";
};
var apiDomain = getApiDomain();
var AxiosInstanceHubPublic = /** @class */ (function () {
    function AxiosInstanceHubPublic() {
        this.requester = axios.create({
            baseURL: "https://".concat(apiDomain, ".360dialog.io/v1")
        });
    }
    return AxiosInstanceHubPublic;
}());
export default new AxiosInstanceHubPublic();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVxdWVzdEF4aW9zSHViUHVibGljLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUmVxdWVzdEF4aW9zSHViUHVibGljLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBd0IsTUFBTSxPQUFPLENBQUM7QUFFN0MsSUFBTSxZQUFZLEdBQUc7SUFDbkIsSUFBTSxHQUFHLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUM7SUFDcEMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxHQUFJLENBQUM7UUFBRSxPQUFPLGtCQUFrQixDQUFDO0lBQzlELElBQUksR0FBRyxJQUFJLENBQUMsU0FBUyxFQUFFLE9BQU8sQ0FBQyxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUM7UUFBRSxPQUFPLGFBQWEsQ0FBQztJQUNwRSxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMsQ0FBQztBQUVGLElBQU0sU0FBUyxHQUFHLFlBQVksRUFBRSxDQUFDO0FBRWpDO0lBR0U7UUFDRSxJQUFJLENBQUMsU0FBUyxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUM7WUFDNUIsT0FBTyxFQUFFLGtCQUFXLFNBQVMscUJBQWtCO1NBQ2hELENBQUMsQ0FBQztJQUNMLENBQUM7SUFDSCw2QkFBQztBQUFELENBQUMsQUFSRCxJQVFDO0FBRUQsZUFBZSxJQUFJLHNCQUFzQixFQUFFLENBQUMifQ==